import icons from 'assets/icons'
import Button from 'components/formElements/Button'
import { useRequest } from 'hooks/useRequest'
import useToast from 'hooks/useToast'
import { Dialog } from 'primereact/dialog'
import { InputText } from 'primereact/inputtext'
import React, { useState } from 'react'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { deleteUser, setUsers } from 'redux/features/users/usersSlice'
import { Checkbox } from "primereact/checkbox";
import ApprovalContent from 'components/modalContent/ApprovalContent'
import { closeApprovalModal, openApprovalModal } from 'redux/features/general/generalSlice'
import { Paginator } from 'primereact/paginator'
import { validateEmail } from 'utils/MailValidator'
import { InputMask } from "primereact/inputmask";
import DefaultSelect from 'components/formElements/DefaultSelect'

const UsersList = ({ listType, createUser, filterOptions }) => {
	const [getUsers] = useRequest()
	const [deleteTableRow] = useRequest()
	const dispatch = useDispatch()
	const { users, general } = useSelector((state) => state)
	const { usersData } = users
	const { approvalModal } = general
	const [slice, setSlice] = useState({ start: 0, end: 9 })
	const [getAllRoles] = useRequest()
	const [addToRoles] = useRequest()
	const [roles, setRoles] = useState([])
	const [editUser, setEditUser] = useState({ open: false, user: {} })
	const [addUser] = useRequest()
	const { showToast } = useToast()
	const [addLogForm, setAddLogForm] = useState({
		firstName: '',
		lastName: '',
		newPassword: null,
		phoneNumber: '',
		isNewPassword: false,
		reNewPassword: null,
		password: null,
		email: '',
		accountId:'',
		
	})

	useEffect(() => {
		if (editUser.open) {
			getAllRoles('/Role/GetAllRoles', { method: 'GET' }).then(res => {
				setRoles(res.data.result.map(r => ({ label: r.name, value: r.name == 'Accounting' ? 'ACCOUNTİNG' : r.name.toUpperCase() })))
			})
			setAddLogForm({ firstName: editUser.user.firstName, lastName: editUser.user.lastName, email: editUser.user.email, phoneNumber: editUser.user.phoneNumber,accountId:editUser.user.accountId, roles: editUser.user?.roles?.map(r => ({ label: r.name, value: r.normalizedName })) })
		} else if (!createUser && !editUser.open) {
			getUsers('/Account/GetAllUsers', {
				method: 'GET',
				params:{
					isDeleteFilter:true
				}
			}).then((res) => {
				if (res.data.ok) {
					dispatch(setUsers(res.data.result))
				}
			})
		}
	}, [editUser.open, createUser])
	const handleChange = (e, name) => {
		if (name) {
			setAddLogForm((prev) => ({ ...prev, [name]: e }))
		} else {
			setAddLogForm((prev) => ({ ...prev, [e.target.name]: e.target.value }))
		}
	}
	const handleDeleteRow = (deleteData, deleteEndpoint) => {
		dispatch(openApprovalModal({ open: true, content: 'Silmek istedğinize emin misiniz?', deleteData, deleteEndpoint }))
	}
	const handleSubmitApproval = () => {
		deleteTableRow(approvalModal.deleteEndpoint, {
			method: 'POST',
			params: {
				email: approvalModal.deleteData
			},
		}).then(async (res) => {
			if (!res.data.metadata) {
				dispatch(deleteUser(approvalModal.deleteData))
				showToast('Kullanıcı Silindi', 'success')
				await handleCloseApprovalModal()
			} else {
				showToast(res.data?.metadata?.message, 'error')
			}
		})
	}
	const handleCloseApprovalModal = async () => {
		dispatch(closeApprovalModal())
	}
	const handleSubmit = async () => {
		if (!addLogForm.firstName) {
			showToast('Kullanıcı Adını Giriniz', 'error')
		} else if (!addLogForm.lastName) {
			showToast('Kullanıcı Soyadını Giriniz', 'error')
		} else if (!validateEmail(addLogForm.email)) {
			showToast('Kullanıcı Mail Adresini Doğru Formatta Giriniz', 'error')
		}
		else if (addLogForm.isNewPassword) {
			if ( !addLogForm.newPassword || !addLogForm.reNewPassword) {
				showToast('Yeni Şifre ve Yeni Şifre Tekrar alanlarını eksiksiz doldurunuz', 'error')
			} else if (addLogForm.newPassword != addLogForm.reNewPassword) {
				showToast('Yeni Şifre ve Yeni Şifre Tekrar alanları birbirinden farklı', 'error')
			} else if (addLogForm.newPassword.length < 6) {
				showToast('Şifreniz 6 karakterden büyük olmalı', 'error')
			} else {
				addUser('/Account/UpdateUser', {
					method: 'POST',
					data: { firstName: addLogForm.firstName, lastName: addLogForm.lastName, phoneNumber: addLogForm.phoneNumber, email: addLogForm.email, accountId:addLogForm.accountId, password: addLogForm.newPassword, oldPassword: addLogForm.password },
				}).then((res) => {
					if (res.statusText == 'OK') {
						if (addLogForm.roles) {
							addToRoles('/Account/AddToRoles', {
								method: 'PUT',
								data: { email: addLogForm.email, roles: Array.isArray(addLogForm?.roles) ? addLogForm?.roles?.map(r => r.value) : [addLogForm.roles.value] }
							}).then(res => {
								if (res.data.ok) {
									showToast('Kullanıcı Güncellendi', 'success')
									setEditUser({ open: false, user: {} })
								}
							})
						} else {
							showToast('Kullanıcı Güncellendi', 'success')
							setEditUser({ open: false, user: {} })
						}
					}else {
						showToast('Bir hata oluştu', 'error')
					}
				})
			}
		}
		else {
			addUser('/Account/UpdateUser', {
				method: 'POST',
				data: { firstName: addLogForm.firstName, lastName: addLogForm.lastName, phoneNumber: addLogForm.phoneNumber, email: addLogForm.email, accountId:addLogForm.accountId, password: null, oldPassword: null },
			}).then((res) => {
				if (res.data) {
					if (addLogForm.roles) {
						addToRoles('/Account/AddToRoles', {
							method: 'PUT',
							data: { email: addLogForm.email, roles: Array.isArray(addLogForm?.roles) ? addLogForm?.roles?.map(r => r.value) : [addLogForm.roles.value] }
						}).then(res => {
							if (res.data.ok) {
								showToast('Kullanıcı Güncellendi', 'success')
								setEditUser({ open: false, user: {} })
							}
						})
					} else {
						showToast('Kullanıcı Güncellendi', 'success')
						setEditUser({ open: false, user: {} })
					}
				}
			})
		}
	}
	const filteredUsers = usersData.filter(d => {
		const keys = Object.keys(filterOptions)
		let rt = [true]
		if (keys.length > 0) {
			keys.forEach(k => {
				if (filterOptions[k] != null) {
					if (k == 'searchText') {
						rt.push(d.firstName.toLowerCase().includes(filterOptions[k].toLowerCase()) || d.lastName.toLowerCase().includes(filterOptions[k].toLowerCase()))
					}
					else {
						rt.push(d.id == filterOptions[k])
					}

				}
			})
		}
		return rt.every(r => r)
	})

	return (
		<div className='users-list'>
			{listType == 2 ? (
				<div className="row">
					{
						filteredUsers?.slice(slice.start, slice.end).map((user, i) => (
							<div key={i} className="col-md-4 mt-4">
								<div className='card users-list-card' >
									<div className='users-list-card-top'>
										<div className='users-list-card-top-left'>
											<div className='users-list-card-top-left-avatar'>
												{user?.firstName[0]}
												{user?.lastName[0]}
											</div>
										</div>
										<div className='users-list-card-top-right'>
											<div className='text-bold'>
												{user?.firstName} {user?.lastName}
											</div>
										</div>
									</div>
									<div className='users-list-card-body'>
										{/* <div>
											{' '}
											<icons.phone className='users-list-card-body-icon' size={25} />{' '}
											<span className='text-sm'>{user?.phoneNumber ? user.phoneNumber : '-'}</span>{' '}
										</div> */}
										<div>
										<icons.user className='users-list-card-body-icon' size={25} /> <span className='text-sm'>{user?.roles?.map(r => r.name)?.join(',')}</span>{' '}
										</div>
										<div>
											{' '}
											<icons.mail className='users-list-card-body-icon' size={25} /> <span className='text-sm'>{user?.email}</span>{' '}
										</div>
										
									</div>
									<div className='users-list-card-settings'>
										<icons.delete onClick={() => handleDeleteRow(user.email, '/Account/DeleteUser')} className='users-list-card-settings-icon' size={28} />
										<icons.edit onClick={() => setEditUser({ open: true, user: user })} className='users-list-card-settings-icon' size={30} />
									</div>
								</div>
							</div>
						))
					}
				</div>
			) : (
				<div className='users-list-card1 flex-column mt-4'>
					{filteredUsers?.slice(slice.start, slice.end).map((user, i) => (
						<div className='users-list-card1-tr' key={i}>
							<div className='users-list-card1-tr-avatar p-0'>
								{user?.firstName[0]} {user?.lastName[0]}
							</div>
							<div className='d-flex align-items-center flex-1 flex-wrap row'>
								<div className='col-md-3'>
									{user?.firstName} {user?.lastName}
								</div>
								{/* <div className='d-flex align-items-center col-md-4'> {user?.phoneNumber ? user.phoneNumber : '-'}</div> */}
								<div className='d-flex align-items-center col-md-3'>{user?.roles?.map(r => r.name)?.join(',')}</div>
								<div className='d-flex align-items-center col-md-3'>{user?.email}</div>

							</div>
							<div className='users-list-card1-tr-icon'>
								<icons.delete onClick={() => handleDeleteRow(user.email, '/Account/DeleteUser')} className='users-list-card-settings-icon mr-1' size={32} />
								<icons.edit onClick={() => setEditUser({ open: true, user: user })} className='users-list-card-settings-icon' size={32} />
							</div>
						</div>
					))}{' '}
				</div>
			)}
			<div className="row mt-2">
				<div className="col-md-12 px-0">
					<div className="card p-1">
						<Paginator first={slice.start} rows={9} totalRecords={filteredUsers.length} onPageChange={(e) => { setSlice({ start: e.first, end: e.first + 9 }) }} />
					</div>
				</div>
			</div>
			<Dialog draggable={false} visible={approvalModal.open} onHide={handleCloseApprovalModal}>
				<ApprovalContent handleClose={handleCloseApprovalModal} handleApproved={handleSubmitApproval} z />
			</Dialog>
			<Dialog visible={editUser.open} onHide={() => setEditUser({ open: false, user: {} })} draggable={false} header='Kullanıcı Düzenle'>
				<div className='form d-flex flex-column gap-3'>
					<div className='row'>
						<div className='col-md-6'>
							<div className='form-control'>
								<InputText placeholder={'Kullanıcı Adı'} name='firstName' value={addLogForm.firstName} type='text' onChange={handleChange} />
							</div>
						</div>
						<div className='col-md-6'>
							<div className='form-control'>
								<InputText placeholder={'Kullanıcı Soyadı'} name='lastName' type='text' value={addLogForm.lastName} onChange={handleChange} />
							</div>
						</div>
					</div>
					<div className='row'>
						<div className='col-md-12'>
							<div className='form-control'>
								<InputText disabled name='email' placeholder={'Email Adresi'} type='email' value={addLogForm.email} onChange={handleChange} />
							</div>
						</div>
					</div>
					<div className="row">
						<div className='col-md-12'>
							<div className='form-control'>
								<DefaultSelect name='roles' placeholder={'Kullanıcı Rolü'} isMulti selectOptions={roles} value={addLogForm.roles} handleChange={(e) => handleChange(e, 'roles')} />
							</div>
						</div>
					</div>
					<div className='row'>
						<div className='col-md-12'>
							<div className='form-control'>
								<InputMask name='phoneNumber' mask="(999) 999-9999" placeholder={'Telefon Numarası'} value={addLogForm.phoneNumber} onChange={handleChange} />
							</div>
						</div>
					</div>
					<div className="row">
						<div className="col-md-12">
							<div className="d-flex gap-2">
								<Checkbox inputId='isNevPassword' checked={addLogForm.isNewPassword} onChange={() => setAddLogForm(prev => ({ ...prev, isNewPassword: !prev.isNewPassword }))} />
								<label htmlFor='isNevPassword' className="form-control-label">Şifre Değiştirmek İstiyorum</label>
							</div>
						</div>
					</div>
					{
						addLogForm.isNewPassword && <>
							<div className='row'>
								<div className='col-md-6'>
									<div className='form-control'>
										<InputText name='newPassword' placeholder={'Yeni Şifre'} type='password' value={addLogForm.newPassword} onChange={handleChange} />
									</div>
								</div>
								<div className='col-md-6'>
									<div className='form-control'>
										<InputText name='reNewPassword' placeholder={'Yeni Şifre Tekrar'} type='password' value={addLogForm.reNewPassword} onChange={handleChange} />
									</div>
								</div>
							</div>
						</>
					}
					<div className='row'>
						<div className='col-md-6 offset-md-6'>
							<div className='form-control align-items-end '>
								<Button
									icon={<icons.addUser className='mr-1' size={20} />}
									className='btn-success'
									title='Bilgileri Güncelle'
									handleClick={handleSubmit}
								/>
							</div>
						</div>
					</div>
				</div>
			</Dialog>
		</div>
	)
}

export default UsersList
